import { reactive, Div, H3, Button, Label, TextArea, RadioInput, Input, Span, P, Checkbox, Hr, Form, not } from 'alkali'
import Dialog from '../generic/DialogAlkali'
import { screening, updateScreeningName } from 'model/Screening'
import { questionToText } from 'analysis/Question'
import { liveParsed, analysisSelections } from 'model/SearchQuery'
import { isEqual } from 'lodash'
import TypeAheadInput from 'components/generic/TypeAheadInput'
import { get } from 'tools/request'

import Icon from 'components/Icon'
import * as TagIcon from 'icons/tags.svg'
import * as CloseIcon from 'icons/close.svg'
import LoadingDots from '../generic/LoadingCircle';

let name = reactive('')
let referenceUrl = reactive('')
let tags = reactive([''])
let screeningName = reactive('')
let description = reactive('')
let availableTags
let formEdited = reactive(false)
let timeout = null

const loadingState = () => {
    const submitButton = document.querySelector('#submit-naming')
    submitButton.disabled = true;
    submitButton.innerHTML = '';
    submitButton.appendChild(new LoadingDots)
}
// TO DO: check if form has been changed and style submit button with disabled or not disabled if tru
// Commented out for now as formobject with reactive variables change so it isn't just a snapshot of the value but doesn't hold the correct value if not reactive
// interface FormObject {
// 	queryName ?: alkali.Vstring,
// 	queryTags ?: alkali.VArray<string>,
// 	screeningName ?:  alkali.Vstring,
// 	screeningDescription ?:  alkali.Vstring
// }
// let formContent:FormObject = {
// 	queryName : name,
// 	queryTags : tags,
// 	screeningName: screening.shortName,
// 	screeningDescription : screening.description
// }

// const onChange = (event) => {
// 	console.log("Original object: ", formContent)
// 	timeout = null
// 	// Make a new timeout set to go off in 1000ms (1 second)
// 	timeout = setTimeout(function () {
// 		console.log("form event info:", event)
// 		let eventTarget = event.target.id
// 		let eventValue = event.target.value
// 		switch(eventTarget) {
// 			case 'name-input':
// 				formEdited.put(formContent.queryName?.valueOf() != eventValue)
// 				break;
// 			case 'tags-input':
// 				formEdited.put(formContent.queryTags.valueOf().length !== tags.valueOf().length)
// 				console.log("Form edited tags: ", tags)
// 				console.log("Form edited value: ", formEdited.valueOf())
// 				console.log("Form edited value: ", formContent.queryTags)
// 				break;
// 			case 'screening-name-input':
// 				formEdited.put(formContent.screeningName?.valueOf() != eventValue)
// 				break;
// 			case 'description-input':
// 				formEdited.put(formContent.screeningDescription?.valueOf() != eventValue)
// 				break;
// 		}
// 		console.log("Target: ", eventTarget, " + ", eventValue)
// 	}, 1000);
// }
let newTag = reactive('')
let newTagValue = reactive('')
let tagInput =  new TypeAheadInput({
	id: 'tags-input',
	content: newTag,
	valueVar: newTagValue,
	maxLength: 25,
	source: {
		findExact(str) {
			return Promise.resolve({ name: str })
		},
		findMatches(str) {
			return availableTags.then(availableTags =>
				availableTags.filter(tag =>
					tag.includes(str) && !tags.valueOf()?.includes(tag)).map(tag => ({ name: tag })))
		},
		itemToEntry(item) {
			return { label: item.name }
		},
		itemToText(item) {
			return item.name
		}
	},
	onkeypress(e) {
		e.stopPropagation()
		if (e.key == 'Enter') {
			addTag()
		}
	},
	['ontypeahead:select'](e) {
		e.stopPropagation()
		addTag()
	}
})

const addTag = () => {
	if(newTag.valueOf()){
		if(tags.valueOf().length == 6){
			alert('A query can have up to six tags. To add a tag, please delete one from the current selections.')
		} else {
			tags.push(newTag.valueOf().trim())
			tagInput.value = ''
			newTag.put('')
			newTagValue.put('')
		}
	} else {
		alert('Tags cannot be empty')
	}
}
export class NamingDialog extends Dialog {
	get defaults() {
		return {
			head: {
				titleText: 'Query Name & Tagging',
			},
			id: 'naming-dialog',
			foot: {},
		}
	}
	ready(properties) {
		const queryDialog = properties.content == 'query'
		let currentQuestion = questionToText(liveParsed.annotations.valueOf())
		this.body.append(
			queryDialog ? null : H3(['Query']),
			P([
				'Questions you ask in DA are saved and can be found in your shortcuts on the landing page. To help distinguish a question from others, you can add any of the additional fields below.'
			]),
			Form('#naming-form',
				[
					Label('.query-question', [
						Span('.strong', ['Question']),
						currentQuestion
					]),
					Label([
						Span('Name'),
						Input(name, {
							id: 'name-input',
							maxLength: 100,
							type: 'text',
							placeholder: currentQuestion,
						}),
					]),
					Label([
						Span('Tags'),
						Div('.tagging-container', [,
							Div('.tagging-input-container',[
								Icon('.tag-icon', { icon: TagIcon }),
								tagInput,
								Button('#submit-tag.primary', ['Add'], {type: 'button', onclick: (e) => {
									addTag()
								}})
							]),
							Div('.analysis-tags',
								tags.map(tag => {
									return Div('.analysis-tag', [
										Span('.tag-name', tag),
										Icon('.analysis-tag-remove', {
											icon: CloseIcon,
											onclick() {
												tags.splice(tags.indexOf(tag), 1)
											}
										})
									])
								}),
							),
						]),
					]),
					Label([
						Span('URL'),
						Input(referenceUrl, {
							placeholder: 'URL of original publication',
							id: 'reference-url-input',
							type: 'text',
						}),
					]),
					screening.ownsScreening().to(screening => screening ?
						Div('.screening-content', [
							Hr(),
							H3(['Screening']),
							Label([
								Span('Name'),
								Input(screeningName, {
									id: 'screening-name-input',
									maxLength: 100,
									type: 'text',
									placeholder: screening.shortName,
								}),
							]),
							Label('.screening-description', [
								Span('Description'),
								TextArea({
									id: 'description-input',
									placeholder: 'Screening project description',
									value: description
								}),
							]),
						]) : null
					)
				]
			),
		)
		this.footer.leftControls.append(
			Button('.btn.secondary', {
				textContent: 'Cancel',
				type: 'submit',
				onclick: () => {
					this.hide()
				},
			}),
		),
			this.footer.rightControls.append(
				Button('.btn.primary#submit-naming', {
					textContent: 'Save',
					// disabled: not(formEdited),
					onclick: async () => {
						if (analysisSelections.referenceUrl.valueOf() != referenceUrl.valueOf()) {
							let updatedName = referenceUrl.valueOf()?.trim()
							if (!updatedName || updatedName.match(/https?:\/\/\w+\./))
								analysisSelections.referenceUrl.put(updatedName)
							else
								return alert('"' + updatedName + '" does not appear to be a valid URL')
						}
						loadingState()
						// Query name
						if (analysisSelections.name.valueOf() != name.valueOf()) {
							let updatedName = name.valueOf()?.trim()
							analysisSelections.name.put(updatedName)
						}
						// Tags
						if (!isEqual(tags.valueOf(), analysisSelections.tags.valueOf() || []))
							analysisSelections.tags.put(tags.valueOf())
						if (!screening.valueOf())
							return this.hide()
						// Screening name
						let formScreeningName = screeningName.valueOf()?.trim()
						let updatedSN = false
						if(formScreeningName){
							updatedSN = formScreeningName != screening.shortName
						}
						let formDescription = description.valueOf()?.trim()
						let updatedDescription
						if(formDescription){
							updatedDescription = formDescription != screening.description.valueOf()
						}
						try {
							await updateScreeningName({
								name: formScreeningName,
								description
							})
							updatedSN && screening.shortName.put(formScreeningName)
							updatedDescription && screening.description.put(formDescription)
							this.hide()
						} catch (error) {
							if (error.message.includes('duplicate key value violates unique constraint'))
								alert('That screening name is already in use, please choose a different name')
							else
								alert(error.message)

						}
					},
				}),
			)
	}
	show(event) {
		name.put(analysisSelections.name.valueOf())
		tags.put(analysisSelections.tags.valueOf()?.slice(0) || [])
		referenceUrl.put(analysisSelections.referenceUrl.valueOf())
		screeningName.put(screening.shortName.valueOf())
		description.put(screening.description.valueOf())
		availableTags = get('/portal/TagByClient')
		super.show(event)
		// const formElement = document.getElementById('naming-form')
		// formElement.addEventListener("input", onChange)
	}
}
